module.exports = __webpack_public_path__ + "static/06-9dcce1ccbd2987a1a767ddefeb533d98.jpg";